module.exports = __webpack_public_path__ + "img/eth.86ddf093.png";